<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18mBqVQ/tc-custom/9780830847495.jpg?1696024732252" alt="This image is the cover for the book Forty Days on Being a Four, Enneagram Daily Reflections"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forty Days on Being a Four, Enneagram Daily Reflections
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>"How are you feeling?"</strong> </p> <p>Christine Yi Suh says that this has always been a hard question. She writes: "The more accurate question for a Four may be, 'What aren't you feeling?' I can grab my prevailing emotion and tell you how I'm doing from that emotion's point of view (joy, elation, sadness, grief, confusion—you name it!). I live and breathe a kaleidoscope of living, feeling, conflicting emotions."</p> <p>Many times Fours are labeled "emotionally intense" or "too much," but for a Four this is just how life is. This is why Fours are ideal companions in the midst difficult times: the death of a loved one, the birth of a baby, transitional seasons in career, relational conflict, and so on.</p> <p>The Enneagram is a profound tool for empathy, so whether or not you are a Four, you will grow from your reading about Four and enhance your relationships across the Enneagram spectrum. Each reading concludes with an opportunity for further engagement such as a journaling prompt, reflection questions, a written prayer, or a spiritual practice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christine Yi Suh, Suzanne Stabile
      </h2>
      
      <p class="authorDescription body article"><p>Christine Yi Suh is a writer, spiritual director, and pastor. She has previously served as a pastor of spiritual formation and as the assistant director of spiritual formation and care at Pepperdine University. Christine received her MA in theology from Gordon-Conwell Theological Seminary and is a graduate of the Renovaré Institute for Christian Spiritual Formation. She is a regular contributor to Missio Alliance and the Nine Beats Collective. She and her spouse, David, live with their two children outside of Los Angeles.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?016817a9